<div class="container">
    <div class="login-area">
        <h5>{{'passwordReset.heading.title' | translate}}</h5>
        <h6>{{'passwordReset.heading.supportingText' | translate}}</h6>

        <form [formGroup]="resetForm" (ngSubmit)="reset()" class="ui form">
            <div class="col-md-12 col-sm-12">
                <div class="form-group row">
                    <br />
                    <label for="pincode">{{'passwordReset.fields.labels.email' | translate}}</label>
                    <input #input formControlName="custEmail" type="text" class="form-control input-sm" placeholder=""
                        [autofocus]>
                    <!--<div [hidden]="custEmail.valid">Required</div>-->
                    <div *ngIf="resetForm.controls['custEmail'].hasError('required') && resetForm.controls['custEmail'].touched"
                        class="alert alert-danger">{{'passwordReset.fields.validation.errors.email' | translate}}</div>

                </div>
                <div class="row button-top">
                    <div class="col-xs-12 col-sm-4">
                        <button [disabled]="!resetForm.valid" type="submit"
                            class='btn btn-primary btn-main btn-inlineblock'>{{'passwordReset.buttons.submit' |
                            translate}}</button>
                    </div>
                </div>
            </div>
        </form>
    </div>

</div>